const getPlaylistTooltipMetrics = ({
  fulfilled,
  hasNoData,
  selectedTempEntity,
  yScale,
}: any): any => {
  const playlistMetrics: any = [];
  if (fulfilled.position && !hasNoData.position && yScale.positionYScale) {
    playlistMetrics.push({
      metric: 'position',
      fieldName: 'position',
      top: yScale?.positionYScale(selectedTempEntity?.position),
    });
  }
  if (fulfilled.stream && !hasNoData.stream && yScale.streamYScale) {
    playlistMetrics.push({
      metric: 'streams',
      fieldName: 'streamCount',
      top: yScale?.streamYScale(selectedTempEntity?.streamCount),
    });
  }
  return playlistMetrics;
};

export default getPlaylistTooltipMetrics;
